<template>
  <ModalConfirmAction
    title="Excluir categoria"
    message="Você tem certeza que deseja remover a categoria?"
    confirmText="Excluir"
    :loading="loading"
    @confirm="deleteCategoria"
  >
    <template #activator="{ on, attrs }">
      <div class="table-action-box table-action-delete" v-bind="attrs" v-on="on">
        <v-icon small>mdi-delete-outline</v-icon>
        <span class="table-action-label">Excluir</span>
      </div>
    </template>
  </ModalConfirmAction>
</template>

<script>
import { apiClient } from "@/services/api";
import ModalConfirmAction from "../ModalConfirmAction.vue";

export default {
  name: "ExcluirCategoriaDialog",
  components: { ModalConfirmAction },
  props: {
    idCategoria: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async deleteCategoria() {
      this.loading = true;

      try {
        await apiClient.delete(`/enquetes/categorias/${this.idCategoria}`);

        this.$toast.success("Categoria excluída com sucesso!");
        this.$emit("categoriaExcluida", this.idCategoria);
      } catch (error) {
        const apiMessage = error?.response?.data?.error;
        this.$toast.error(apiMessage || "Erro ao excluir categoria...");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
